module.exports = __webpack_public_path__ + "h5/img/noAddress.e4c3b7cd.png";